export enum RoutesEnum {
    BASE = '/',
    DASHBOARD = '/dashboard',
    PATHS = '/paths',
    DATA = '/data',
    REPORTS = '/reports',
    VISITS = '/visits',
    ACCOUNT = '/settings/account',
    LOGOUT = '/logout',
    FORGOT_PASSWORD = '/forgot-password',
    PASSWORD_RESET = '/password-reset',
    SETTINGS = '/settings',
    DEVICES = '/settings/devices',
    TERMS_AND_CONDITIONS = '/settings/terms-and-conditions',
    PRIVACY_POLICY = '/settings/privacy-policy',
    SUPPORT = '/settings/support',
    LOGIN = '/login',
    INVITE = '/invite',
}
